import { render, staticRenderFns } from "./CreateASigningURL.vue?vue&type=template&id=2c247ef4&scoped=true"
import script from "./CreateASigningURL.vue?vue&type=script&lang=js"
export * from "./CreateASigningURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c247ef4",
  null
  
)

export default component.exports